<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H7C6.44772 17 6 16.5523 6 16C6 15.4477 6.44772 15 7 15H12Z" fill="currentColor" />
        <path d="M17 11C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H17Z" fill="currentColor" />
        <path d="M17 7C17.5523 7 18 7.44772 18 8C18 8.55228 17.5523 9 17 9H7C6.44772 9 6 8.55228 6 8C6 7.44772 6.44772 7 7 7H17Z" fill="currentColor" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20 3C21.1046 3 22 3.89543 22 5V19C22 20.1046 21.1046 21 20 21H6.41406L5.41406 22C4.19345 23.2205 2.13325 22.4212 2.00586 20.75L2 20.5859V5C2 3.89543 2.89543 3 4 3H20ZM4 20.5859L5 19.5859L5.14648 19.4531C5.50237 19.1614 5.94989 19 6.41406 19H20V5H4V20.5859Z"
            fill="currentColor"
        />
    </svg>
</template>
